import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import Spinner from '../Spinner.jsx';
import CheckboxIcon from './CheckboxIcon.jsx';
import styles from './Checkbox.scss';

const Checkbox = ({
  checked,
  children,
  className,
  disabled,
  indeterminate,
  inline,
  loading,
  name,
  onChange,
  value,
  ...rest
}) => (
  <label
    className={classnames(
      className,
      styles.component,
      disabled && styles.disabled,
      inline && styles.inline,
    )}
    onKeyPress={event => {
      if (event.charCode === 32) {
        onChange({target: {checked: !checked}});
      }
    }}
    {...rest}
  >
    <input
      className={styles.hiddenCheckbox}
      checked={checked}
      disabled={disabled}
      name={name}
      onChange={onChange}
      value={value}
      type="checkbox"
    />
    {
      loading &&
      <Spinner style={{
        height: '14px',
        marginLeft: '1px',
        marginRight: '9px',
        marginTop: '1px',
        width: '14px',
      }}/>
    }
    {
      !loading &&
      <CheckboxIcon
        checked={checked}
        indeterminate={indeterminate}
      />
    }
    {children}
  </label>
);

Checkbox.propTypes = {
  checked: PropTypes.bool,
  children: PropTypes.node,
  disabled: PropTypes.bool,
  indeterminate: PropTypes.bool,
  inline: PropTypes.bool,
  loading: PropTypes.bool,
  onChange: PropTypes.func,
  value: PropTypes.any
};

Checkbox.defaultProps = {
  checked: false,
  disabled: false,
  indeterminate: false,
  inline: false,
  loading: false,
  onChange: () => {}
};

export default Checkbox;
